import { ToolbarIcon } from 'src/components/RichTextEditor';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { Modals, useShowModals } from 'src/store/modals';

export const AiAssistantTrigger = ({
  onSubmit,
}: {
  onSubmit?: (promptId?: string, promptName?: string, customPrompt?: string) => Promise<void>;
}) => {
  const [showAiPromptsModal] = useShowModals(Modals.AiPrompts);
  const { checkValidity } = useGroupRules();
  const hasAccessToAiAssistant = checkValidity([UserGroupRules.AiAssistant]);

  if (!hasAccessToAiAssistant) return null;

  return (
    <ToolbarIcon
      data={{
        onClick: () =>
          showAiPromptsModal({
            onSubmit,
          }),
        title: 'AI Assistant',
        icon: 'auto_awesome',
        disabled: false,
      }}
    />
  );
};
